// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePhoneResponseDTOAPIModel
 */
export interface UpdatePhoneResponseDTOAPIModel {
    /**
     * 
     * @type {number}
     * @memberof UpdatePhoneResponseDTOAPIModel
     */
    attempt: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePhoneResponseDTOAPIModel
     */
    validTill: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePhoneResponseDTOAPIModel
     */
    resendAfter: Date;
}

export function UpdatePhoneResponseDTOAPIModelFromJSON(json: any): UpdatePhoneResponseDTOAPIModel {
    return UpdatePhoneResponseDTOAPIModelFromJSONTyped(json, false);
}

export function UpdatePhoneResponseDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhoneResponseDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attempt': json['attempt'],
        'validTill': (new Date(json['validTill'])),
        'resendAfter': (new Date(json['resendAfter'])),
    };
}

export function UpdatePhoneResponseDTOAPIModelToJSON(value?: UpdatePhoneResponseDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attempt': value.attempt,
        'validTill': (value.validTill.toISOString()),
        'resendAfter': (value.resendAfter.toISOString()),
    };
}


